import { atom } from "recoil";
import { IFileCategory } from "../types";

export const addStateFileCategory = atom({
  key: "addStateFileCategory",
  default: false,
});
export const editStateFileCategory = atom({
  key: "editStateFileCategory",
  default: false,
});
export const rowEditFileCategory = atom<IFileCategory | undefined>({
  key: "rowEditFileCategory",
  default: undefined,
});

export const selectedRowsStateFileCategory = atom<IFileCategory[]>({
  key: "selectedRowsStateFileCategory",
  default: [],
});

export const fileCategoryFilterText = atom({
  key: "fileCategoryFilterText",
  default: "",
});

export const fileCategoryFetching = atom({
  key: "fileCategoryFetching",
  default: true,
});

export const fileCategoryReFetching = atom({
  key: "fileCategoryReFetching",
  default: false,
});
